export default __webpack_public_path__ + "static/media/344.709a732c.jpg";